module.exports = __webpack_public_path__ + "static/media/是否參加政府防災宣導、教育、演習 vs 是否知道住家附近的政府公告避難地點.1a588b5d.png";